import { z } from "zod";
export const createValidationSchema = (inputs) => {
    const schemaObject = {};
    inputs.forEach(input => {
        let schema = z.optional(z.any());
        if (input.required) {
            switch (input.type) {
                case "email":
                    schema = z.email(`${input.label} is required`);
                    break;
                case "boolean":
                    schema = z.boolean(`${input.label} is required`);
                    break;
                case "eth":
                    schema = z.string()
                        .refine((value) => /^0x[a-fA-F0-9]{40}$/.test(value), {
                        message: "Provided address is invalid"
                    });
                    break;
                case "decimals":
                case "number":
                    schema = z.number(`${input.label} is required`);
                    break;
                default:
                    schema = z.string(`${input.label} is required`).min(1, `${input.label} is required`);
            }
            if (input.customRule) {
                schema = schema.superRefine((value, ctx) => {
                    const result = input.customRule(value);
                    if (result !== true) {
                        ctx.addIssue({
                            code: "custom",
                            message: result || "Invalid value"
                        });
                    }
                });
            }
        }
        if (input.name) {
            schemaObject[input.name] = schema;
        }
    });
    return z.object(schemaObject);
};
